export default __webpack_public_path__ + "static/media/ppt4_intro.e5b50557.png";